import { createStyles } from "@mantine/core"

export const useStyles = createStyles((theme) => ({
    container: {
        maxWidth: "1080px",
    },
    header: {
        padding: "1rem 1.25rem 1rem 1.5rem",
        borderBottom: `1px solid ${theme.colors.gray[2]}`,
    },
    title: {
        color: theme.colors.gray[8],
        fontSize: "1.25rem",
        fontWeight: 500,
    },
    body: {
        borderBottom: `1px solid ${theme.colors.gray[2]}`,

        "&": {
            padding: ".75rem .5rem",
        },

        "&:not(:only-child)": {
            paddingTop: ".75rem",
        },
    },
    buttonsGroup: {
        padding: "1rem 1.5rem",
    },
    cell: {
        padding: "1rem",
    },
    headerRow: {
        fontSize: ".875rem",
        color: theme.colors.gray[7],
        display: "flex",
        borderBottom: `1px solid ${theme.colors.gray[3]}`,
    },
    typeCell: {
        flex: 1,
    },
    descriptionCell: {
        flex: 2,
    },
    dataRow: {
        display: "flex",
        fontSize: ".875rem",
        color: theme.colors.gray[9],

        "&:nth-of-type(even)": {
            backgroundColor: theme.colors.gray[0],
        },
    },
    typeData: {
        flex: 1,
        fontSize: "1rem",
        fontWeight: 500,
    },
    moreHelpButton: {
        ".mantine-Button-rightIcon": {
            marginLeft: 0,
            fontSize: ".875rem",
        },
    },
}))
